import { createFileRoute } from "@tanstack/react-router";
import { env } from "@/env";
import { FilSpesifikasjon } from "@/features/dokumentasjon/FilSpesifikasjon";

export const Route = createFileRoute("/_public/dokumentasjon/innrapportering")({
  component: Index,
  head: () => ({
    meta: [
      {
        title: "Dokumentasjon Innrapportering | Norgespris for fjernvarme",
      },
    ],
  }),
});

function Index() {
  // env.appBasePath can be "/" or "/selskapsportal"
  // prefix file paths with "" or "/selskapsportal"
  const appBasePathPrefix =
    env.appBasePath === "/"
      ? ""
      : env.appBasePath.endsWith("/")
        ? env.appBasePath.slice(0, -1)
        : env.appBasePath;

  const markdownFilePublicPath = `${appBasePathPrefix}/dokumentasjon/maalerdata_1.0.md`;
  const exampleFileWindowsPublicPath = `${appBasePathPrefix}/dokumentasjon/maalerdata-eksempel-windows.csv`;
  const exampleFileMacPublicPath = `${appBasePathPrefix}/dokumentasjon/maalerdata-eksempel-utf8.csv`;
  const helpLink = `/veiledning`;

  const markdownFileDownloadName = "filspesifikasjon-maalerdata.md";
  const exampleFileDownloadName = "maalerdata-123456789-2025-09-01.csv";

  return (
    <FilSpesifikasjon
      markdownFilePublicPath={markdownFilePublicPath}
      markdownFileDownloadName={markdownFileDownloadName}
      exampleFileWindowsPublicPath={exampleFileWindowsPublicPath}
      exampleFileMacPublicPath={exampleFileMacPublicPath}
      exampleFileDownloadName={exampleFileDownloadName}
      helpLink={helpLink}
    />
  );
}
